import { ReactNode } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { ChatBot } from '@/components/ChatBot'
import { SkipLink } from '@/components/SkipLink'

interface LayoutProps {
  children: ReactNode
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="flex flex-col min-h-screen">
      <SkipLink />
      <Header />
      <main id="main-content" className="flex-grow" role="main">
        {children}
      </main>
      <Footer />
      <ChatBot />
    </div>
  )
}
